import type { HTMLAttributes, ReactElement } from "react";
import styles from "./Badge.module.css";

export type BadgeTone = "neutral" | "info" | "success" | "warning" | "danger";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

/**
 * A compact, tone-coloured label for a categorical value (a record `status`, a
 * `channel`).
 *
 * **Colour is never the carrier of meaning** (WCAG 1.4.1) — the badge always
 * renders its own text, so it reads identically in greyscale, in a screenshot,
 * and to a colour-blind operator. `tone` only reinforces what the text says.
 */
export function Badge({
  tone = "neutral",
  className,
  children,
  ...rest
}: BadgeProps): ReactElement {
  const classes = [styles.badge, styles[tone], className].filter(Boolean).join(" ");
  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
}
